//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import navbar from '@/components/ui/navbar';

export default {
    name: 'divline',
    components: {navbar},
	data() {
		return {

		}
	},
	mounted(){

	}
}



// WEBPACK FOOTER //
// ./src/views/contract/server.vue